import styled from 'styled-components'
import { memo, useEffect, useRef, useState } from 'react'
import { useLoading } from '../components/Loading'
import {
  fastRegisterAccount,
  loginByPassword,
  sendSmsVerifyCode,
  setAccessToken,
} from '../utils/userApi'
import SmsButton from '../components/SmsButton'
import LogoHead from '../components/LogoHead'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Input, Message, Modal } from '@arco-design/web-react'
import { IconPhone, IconUnlock } from '@arco-design/web-react/icon'
import ZWContract from '../components/ZWContract'

const RegsiterPage = memo(() => {
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  const redirect = queryParams.get('redirect')
  const navigate = useNavigate()
  const { setLoading } = useLoading()
  const phoneRef = useRef(null)
  const smsRef = useRef(null)

  async function onTryLoginBySms (e) {
    const smsCode = smsRef.current.dom.value
    const phone = phoneRef.current.dom.value
    if (!/[0-9]/.test(smsCode)) {
      e.preventDefault()
      Message.error('验证码格式错误')
      return
    }

    const passwd = Date.now().toString()
    setLoading(true)
    const regRsp = await fastRegisterAccount(phone, smsCode, passwd)
    setLoading(false)
    if (regRsp?.code !== 0) {
      Modal.error({
        title: '注册失败',
        content: regRsp['msg'],
      })
      return
    }
    setLoading(true)
    const logRsp = await loginByPassword(phone, passwd)
    setLoading(false)
    if (regRsp?.code !== 0) {
      Modal.error({
        title: '登录失败',
        content: logRsp['msg'],
      })
      return
    }
    await Message.success('注册成功！即将跳转！')

    setAccessToken(logRsp.data['access_token'])
    setTimeout(() => {
      navigate(redirect ?? '/home')
    }, 500)

  }

  const [isAgree, setAgree] = useState(true)

  return <Root>
    <head>
      <title>注册 - Cochiper</title>
    </head>
    <div title="手机验证码注册">
      <LogoHead/>
      <div style={{ padding: 10 }}>

        <div style={{ display: 'flex' }}>
          <Input ref={phoneRef}
                 id="phone"
                 className="item" placeholder="请输入11位手机号码"
                 prefix={<IconPhone/>}
                 style={{
                   margin: 5,
                   height: 40,
                 }}
          />

          <SmsButton
            onClick={async e => {
              setLoading(true)
              const r = await sendSmsVerifyCode(phoneRef.current.dom.value)
              setLoading(false)
              if (r.code !== 0) {
                Modal.error({
                  title: '获取验证码失败',
                  content: r.msg,
                })
              }
            }}
            style={{
              margin: 5,
              height: 40,
              marginRight: 30,
            }}>获取验证码</SmsButton>
        </div>
        <Input ref={smsRef}
               length={5}
               className="item" placeholder="请输入5位验证码"
               prefix={<IconUnlock/>}
               style={{
                 margin: 5,
                 height: 40,
                 width: 'calc(100% - 35px)',
               }}
        />

        <Button disabled={!isAgree}
                type="primary"
                onClick={onTryLoginBySms}
                style={{
                  margin: 5,
                  height: 40,
                  width: 'calc(100% - 35px)',
                }}>一键注册</Button>

        <ZWContract setAgree={setAgree}/>
      </div>
    </div>
  </Root>
})

export default RegsiterPage

const Root = styled.div`
  padding: 10px;
`